import type { ReactElement } from 'react'

import { EXPLORE_GRID } from '@/packages/explore/components/ExploreGroup'
import { ProductTile } from '@/packages/explore/components/ProductTile'
import type { Product } from '@/packages/explore/types'

interface ExploreHighlightedProps {
  products: Product[]
  onNavigate?: (() => void) | undefined
  nodeId?: string
}

/**
 * Figma `layout` (2267:290735) — the four red tiles, on the same six-column
 * grid as the groups. On the 700px panel Figma leaves the outer columns empty,
 * so the four sit in columns 2–5; below 900px they fill the row from the left.
 */
export function ExploreHighlighted({
  products,
  onNavigate,
  nodeId,
}: ExploreHighlightedProps): ReactElement {
  return (
    <div data-node-id={nodeId} data-name="layout" className="hub-rule w-full">
      <div className={`${EXPLORE_GRID} pb-4 [&>*:first-child]:md:col-start-2`}>
        {products.map((product) => (
          <ProductTile
            key={product.id}
            product={product}
            variant="highlighted"
            onNavigate={onNavigate}
          />
        ))}
      </div>
    </div>
  )
}
